'use strict';
const _ = require('underscore');
const Backbone = require('backbone');
const VersionRepository = require('data/domain/repository/content/version');

module.exports = Backbone.Model.extend({
    defaults: {
        name: '',
        latestVersion: null,
        updatedAt: null,
        updatedBy: null,
        _versionRepository: null,
        owner: null,
    },

    initialize: function() {
        this._versionsFetched = false;
        this.set({_versionRepository: VersionRepository.find(this)});
        this.on('change:latestVersion', this.updateLatestVersion);
        this.on('change:deleted', this.deleteVersions);
        this.updateLatestVersion();
    },

    toJSON: function() {
        let j = this.constructor.__super__.toJSON.call(this);
        delete j._versionRepository;
        return j;
    },

    path: function() {
        const projectId = this.getProject().id;
        return `/projects/${projectId}/data-contents/${this.id}`;
    },

    toMarkdown: function() {
        const latest = this.getLatestVersion();
        const name = this.getName();

        if(latest.isImage()) {
            const imageURI = latest.getDataSource().getThumbnailURI();
            return `![${name}](${imageURI})`;
        } else {
            return `[${name}](${this.path()})`;
        }
    },

    _getVersionRepository: function() {
        return this.get('_versionRepository');
    },

    _getVersions: function() {
        return this._getVersionRepository().get();
    },

    updateLatestVersion: function() {
        const j = _.extend({}, this.get('latestVersion'));
        j._content = this;
        this.addVersion(j);
    },

    addVersion: function(v) {
        this._getVersions().add(v, {merge: true});
    },

    getLatestVersion: function() {
        return this._getVersions().at(0);
    },

    getVersions: function() {
        return new Promise((resolve, reject) => {
            if(!this._versionsFetched) {
                this.getVersionsMore(10)
                    .then(() => {
                        this._versionsFetched = true;
                        resolve(this._getVersions());
                    })
                    .catch(reject);
            } else {
                resolve(this._getVersions());
            }
        });
    },

    getVersionsMore: function(limit) {
        return this._getVersionRepository().getNext(limit);
    },

    hasNextVersion: function() {
        return this._getVersionRepository().hasNext();
    },

    getVersionByID: function(versionID) {
        return this._getVersionRepository().fetchByID(versionID);
    },

    deleteVersions: function() {
        this._getVersionRepository().deleteVersions();
    },

    getName: function() {
        return this.get('name');
    },

    getContainer: function() {
        return this.get('parent');
    },

    getProject: function() {
        return this.get('_project');
    },

    isDeleted: function() {
        return this.get('deleted');
    },

    getOwner: function() {
        return this.get('owner');
    },

    getUpdatedAt: function () {
        return this.get('updatedAt');
    },

    hasComment: function () {
        return this.get('hasComment');
    },

    hasTask: function () {
        return this.get('hasTask');
    }
});



// WEBPACK FOOTER //
// ./data/domain/entity/content/index.js